// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Video → Images page.
 *
 * Every color is a design token (see src/styles/theme.css) so both themes stay
 * correct — no hardcoded hex, per DESIGN_GUIDE.md. Cards, buttons, badges and
 * the modal shell come from the existing atoms/global layer; this file only
 * adds the layout that is specific to this page.
 */

.v2i-page__head {
  padding: 0.25rem 0 0.5rem;
}

.v2i-page__title {
  color: var(--foreground);
  font-family: var(--font-sans);
  font-weight: 700;
}

.v2i-page__subtitle {
  color: var(--muted-foreground);
  font-size: 0.8125rem;
  max-width: 62ch;
}

.v2i-card {
  height: 100%;
}

/* ---------- shared form bits ---------- */

.v2i-label {
  display: block;
  color: var(--muted-foreground);
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  margin-bottom: 0.25rem;
  text-transform: uppercase;
}

.v2i-hint {
  color: var(--muted-foreground);
  font-size: 0.75rem;
  line-height: 1.45;
}

.v2i-field-group {
  border-top: 1px solid var(--border);
  margin-top: 0.875rem;
  padding-top: 0.875rem;
}

.v2i-field-group:first-child {
  border-top: 0;
  margin-top: 0;
  padding-top: 0;
}

.v2i-section-title {
  color: var(--foreground);
  font-size: 0.8125rem;
  font-weight: 600;
  margin: 1rem 0 0.5rem;
}

.v2i-code {
  background: var(--muted);
  border-radius: var(--radius-sm);
  color: var(--foreground);
  display: inline-block;
  font-family: var(--font-mono);
  font-size: 0.6875rem;
  padding: 0.2rem 0.4rem;
  word-break: break-all;
}

/* ---------- segmented control (sampling mode, resize mode) ---------- */

.v2i-segmented {
  background: var(--muted);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  display: flex;
  gap: 2px;
  padding: 2px;
}

.v2i-segmented__item {
  background: transparent;
  border: 0;
  border-radius: calc(var(--radius) - 3px);
  color: var(--muted-foreground);
  cursor: pointer;
  flex: 1 1;
  font-size: 0.75rem;
  font-weight: 500;
  padding: 0.375rem 0.5rem;
  transition: background var(--transition-fast), color var(--transition-fast);
}

.v2i-segmented__item:hover:not(:disabled) {
  color: var(--foreground);
}

.v2i-segmented__item--active {
  background: var(--card);
  box-shadow: var(--shadow-sm);
  color: var(--foreground);
  font-weight: 600;
}

.v2i-segmented__item:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

/* ---------- quality slider ---------- */

.v2i-range {
  appearance: none;
  background: transparent;
  display: block;
  margin: 0.25rem 0 0.375rem;
  width: 100%;
}

.v2i-range::-webkit-slider-runnable-track {
  background: var(--muted);
  border-radius: var(--radius-full);
  height: 4px;
}

.v2i-range::-moz-range-track {
  background: var(--muted);
  border-radius: var(--radius-full);
  height: 4px;
}

.v2i-range::-webkit-slider-thumb {
  appearance: none;
  background: var(--primary);
  border: 2px solid var(--card);
  border-radius: var(--radius-full);
  box-shadow: var(--shadow-sm);
  cursor: pointer;
  height: 16px;
  margin-top: -6px;
  width: 16px;
}

.v2i-range::-moz-range-thumb {
  background: var(--primary);
  border: 2px solid var(--card);
  border-radius: var(--radius-full);
  cursor: pointer;
  height: 16px;
  width: 16px;
}

.v2i-range:focus-visible {
  outline: 2px solid var(--ring);
  outline-offset: 3px;
}

/* ---------- drop zone ---------- */

.v2i-dropzone {
  align-items: center;
  background: var(--page-bg-subtle);
  border: 2px dashed var(--border-strong);
  border-radius: var(--radius-lg);
  display: flex;
  flex-direction: column;
  padding: 1.5rem 1rem;
  text-align: center;
  transition: background var(--transition), border-color var(--transition);
}

.v2i-dropzone--active {
  background: var(--primary-soft);
  border-color: var(--primary);
}

.v2i-dropzone__icon {
  color: var(--muted-foreground);
  font-size: 1.75rem;
  margin-bottom: 0.5rem;
}

.v2i-dropzone__title {
  color: var(--foreground);
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
}

.v2i-dropzone__or {
  color: var(--muted-foreground);
  font-size: 0.75rem;
  margin-bottom: 0.5rem;
}

.v2i-dropzone__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: center;
  margin-bottom: 0.75rem;
}

/* ---------- upload progress ---------- */

.v2i-upload-progress {
  background: var(--muted);
  border-radius: var(--radius);
  margin-top: 0.875rem;
  padding: 0.625rem 0.75rem;
}

.v2i-upload-progress__label {
  color: var(--foreground);
  font-size: 0.75rem;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.v2i-upload-progress__value {
  color: var(--muted-foreground);
  flex-shrink: 0;
  font-family: var(--font-mono);
  font-size: 0.6875rem;
  padding-left: 0.5rem;
}

.v2i-progress {
  background: var(--secondary);
  border-radius: var(--radius-full);
  height: 6px;
  overflow: hidden;
  width: 100%;
}

.v2i-progress__fill {
  background: var(--primary);
  border-radius: var(--radius-full);
  height: 100%;
  transition: width var(--transition);
}

.v2i-progress__fill--active {
  background: linear-gradient(
    90deg,
    var(--primary) 0%,
    var(--brand-400) 50%,
    var(--primary) 100%
  );
  background-size: 200% 100%;
  animation: v2i-progress-shift 1.4s linear infinite;
}

@keyframes v2i-progress-shift {
  from { background-position: 100% 0; }
  to { background-position: -100% 0; }
}

@media (prefers-reduced-motion: reduce) {
  .v2i-progress__fill--active {
    animation: none;
  }
}

/* ---------- selected file list ---------- */

.v2i-filelist {
  border: 1px solid var(--border);
  border-radius: var(--radius);
  margin-top: 0.875rem;
  overflow: hidden;
}

.v2i-filelist__head {
  background: var(--muted);
  color: var(--muted-foreground);
  display: flex;
  font-size: 0.6875rem;
  font-weight: 600;
  justify-content: space-between;
  padding: 0.375rem 0.625rem;
  text-transform: uppercase;
}

.v2i-filelist__items {
  list-style: none;
  margin: 0;
  max-height: 13rem;
  overflow-y: auto;
  padding: 0;
}

.v2i-filelist__item {
  align-items: center;
  border-top: 1px solid var(--border);
  display: flex;
  gap: 0.5rem;
  padding: 0.375rem 0.625rem;
}

.v2i-filelist__item:first-child {
  border-top: 0;
}

.v2i-filelist__icon {
  color: var(--muted-foreground);
  flex-shrink: 0;
}

.v2i-filelist__name {
  color: var(--foreground);
  flex: 1 1;
  font-size: 0.75rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.v2i-filelist__size {
  color: var(--muted-foreground);
  flex-shrink: 0;
  font-family: var(--font-mono);
  font-size: 0.6875rem;
}

/* ---------- start row ---------- */

.v2i-start {
  align-items: center;
  border-top: 1px solid var(--border);
  display: flex;
  flex-wrap: wrap;
  gap: 0.625rem;
  margin-top: 0.875rem;
  padding-top: 0.875rem;
}

/* ---------- jobs table ---------- */

.v2i-table-wrap {
  overflow-x: auto;
}

.v2i-table {
  border-collapse: collapse;
  /* Wide enough for every column plus three action buttons. Below this the
     wrapper scrolls horizontally, which is what we want — a smaller min-width
     lets the browser crush the action cell and wrap button labels mid-word. */
  min-width: 52rem;
  width: 100%;
}

.v2i-table th,
.v2i-table td {
  padding: 0.5rem 0.5rem;
  text-align: left;
  vertical-align: middle;
  /* A report row must never wrap: the one long field (job name) truncates
     instead, everything else is short and stays on one line. */
  white-space: nowrap;
}

.v2i-table th {
  border-bottom: 1px solid var(--border);
  color: var(--muted-foreground);
  font-size: 0.6875rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  padding: 0.5rem 0.625rem;
  text-transform: uppercase;
}

.v2i-table td {
  border-bottom: 1px solid var(--border);
}

.v2i-table tbody tr:hover {
  background: var(--card-hover);
}

/* The job/target cell is the only elastic one — cap it and ellipsize. */
.v2i-table__job-col {
  max-width: 16rem;
  min-width: 10rem;
  white-space: normal;
}

.v2i-table__primary {
  color: var(--foreground);
  font-size: 0.8125rem;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.v2i-table__secondary {
  color: var(--muted-foreground);
  font-size: 0.6875rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Progress: bar and percentage on one line, so the column stays compact and
   the row keeps a single-line height. */
.v2i-table__progress-col {
  min-width: 8.5rem;
}

.v2i-progress-cell {
  align-items: center;
  display: flex;
  gap: 0.5rem;
}

.v2i-progress-cell .v2i-progress {
  flex: 1 1 auto;
  min-width: 4.5rem;
}

.v2i-progress-cell__value {
  color: var(--muted-foreground);
  flex: 0 0 auto;
  font-family: var(--font-mono);
  font-size: 0.6875rem;
  font-variant-numeric: tabular-nums;
  min-width: 2.75rem;
  text-align: right;
}

/* Pinned to the right edge: on a narrow screen the table scrolls, and the
   actions must not be the thing that scrolls out of reach. */
.v2i-table__actions-col {
  background: var(--card);
  border-left: 1px solid var(--border);
  position: sticky;
  right: 0;
  text-align: right;
}

.v2i-table tbody tr:hover .v2i-table__actions-col {
  background: var(--card-hover);
}

.v2i-table__actions {
  display: flex;
  /* No wrapping: buttons stay on one row and the table scrolls if space runs out. */
  flex-wrap: nowrap;
  gap: 0.375rem;
  justify-content: flex-end;
}

.v2i-table__actions .btn {
  flex: 0 0 auto;
  white-space: nowrap;
}

/* ---------- empty / alerts ---------- */

.v2i-empty {
  color: var(--muted-foreground);
  padding: 2rem 1rem;
  text-align: center;
}

.v2i-empty__icon {
  display: block;
  font-size: 1.75rem;
  margin-bottom: 0.5rem;
  opacity: 0.6;
}

.v2i-empty__title {
  color: var(--foreground);
  font-size: 0.875rem;
  font-weight: 600;
}

.v2i-alert {
  border-radius: var(--radius);
  font-size: 0.75rem;
  line-height: 1.5;
  margin-bottom: 0.75rem;
  padding: 0.5rem 0.75rem;
}

.v2i-alert--danger {
  background: var(--destructive-soft);
  color: var(--destructive);
}

.v2i-alert--warning {
  background: var(--warning-soft);
  color: var(--warning);
}

.v2i-alert__list {
  margin: 0.25rem 0 0;
  padding-left: 1.1rem;
}

/* ---------- detail modal ---------- */

.v2i-modal {
  background: var(--overlay);
  display: block;
}

.v2i-detail-grid {
  display: grid;
  gap: 0.75rem 1rem;
  grid-template-columns: repeat(auto-fit, minmax(13rem, 1fr));
  margin-bottom: 0.875rem;
}

.v2i-detail-grid p {
  color: var(--foreground);
  font-size: 0.8125rem;
}

.v2i-skiplist {
  list-style: none;
  margin: 0 0 0.5rem;
  padding: 0;
}

.v2i-skiplist li {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 0.2rem 0;
}

.v2i-log {
  background: var(--muted);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  color: var(--foreground);
  font-family: var(--font-mono);
  font-size: 0.6875rem;
  line-height: 1.55;
  margin: 0;
  max-height: 14rem;
  overflow: auto;
  padding: 0.625rem;
  white-space: pre-wrap;
  word-break: break-word;
}

/* ---------- table extras ---------- */

.v2i-table__icon {
  color: var(--muted-foreground);
  margin-right: 0.375rem;
}

/* Danger tint for an icon-only destructive action. */
.v2i-icon-btn--danger:hover:not(:disabled) {
  background: var(--destructive-soft) !important;
  border-color: var(--destructive) !important;
  color: var(--destructive) !important;
}

.v2i-hint--info {
  color: var(--info);
  margin-top: 0.25rem;
}

.v2i-alert--info {
  background: var(--info-soft);
  color: var(--info);
}

/* ---------- checkbox row ---------- */

.v2i-checkbox {
  align-items: center;
  color: var(--foreground);
  cursor: pointer;
  display: flex;
  font-size: 0.8125rem;
  gap: 0.5rem;
  margin: 0.5rem 0 0;
}

.v2i-checkbox input {
  accent-color: var(--primary);
  height: 1rem;
  width: 1rem;
}

/* ---------- dataset list ---------- */

.v2i-dataset-grid {
  display: grid;
  gap: 0.75rem;
  grid-template-columns: repeat(auto-fill, minmax(15rem, 1fr));
}

.v2i-dataset-card {
  align-items: center;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  cursor: pointer;
  display: flex;
  gap: 0.75rem;
  padding: 0.625rem;
  text-align: left;
  transition: border-color var(--transition), box-shadow var(--transition);
  width: 100%;
}

.v2i-dataset-card:hover {
  border-color: var(--primary);
  box-shadow: var(--shadow-sm);
}

.v2i-dataset-card__thumb {
  align-items: center;
  background: var(--muted);
  border-radius: var(--radius-sm);
  color: var(--muted-foreground);
  display: flex;
  flex: 0 0 auto;
  height: 3rem;
  justify-content: center;
  overflow: hidden;
  width: 3rem;
}

.v2i-dataset-card__thumb img {
  height: 100%;
  object-fit: cover;
  width: 100%;
}

.v2i-dataset-card__body {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.v2i-dataset-card__name {
  color: var(--foreground);
  font-size: 0.8125rem;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.v2i-dataset-card__count {
  color: var(--muted-foreground);
  font-size: 0.6875rem;
}

/* ---------- dataset detail ---------- */

.v2i-dataset-head {
  align-items: center;
  display: flex;
  gap: 0.625rem;
  min-width: 0;
}

.v2i-dataset-head__name {
  color: var(--foreground);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Keep the back button on one line when the header gets tight. */
.v2i-dataset-head .btn {
  flex: 0 0 auto;
  white-space: nowrap;
}

.v2i-select-bar {
  align-items: center;
  background: var(--muted);
  border-radius: var(--radius);
  display: flex;
  flex-wrap: wrap;
  gap: 0.625rem;
  justify-content: space-between;
  margin-bottom: 0.875rem;
  padding: 0.5rem 0.625rem;
}

.v2i-select-bar__left,
.v2i-select-bar__right {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.v2i-select-bar__count {
  color: var(--muted-foreground);
  font-size: 0.75rem;
}

/* ---------- image grid with multi-select ---------- */

.v2i-image-grid {
  display: grid;
  gap: 0.5rem;
  grid-template-columns: repeat(auto-fill, minmax(7.5rem, 1fr));
  max-height: 32rem;
  overflow-y: auto;
}

.v2i-image-tile {
  background: var(--muted);
  border: 2px solid transparent;
  border-radius: var(--radius);
  cursor: pointer;
  overflow: hidden;
  position: relative;
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
}

.v2i-image-tile:hover {
  border-color: var(--border-strong);
}

.v2i-image-tile:focus-visible {
  outline: 2px solid var(--ring);
  outline-offset: 2px;
}

.v2i-image-tile--selected {
  border-color: var(--primary);
  box-shadow: 0 0 0 2px var(--primary-soft);
}

.v2i-image-tile__img {
  aspect-ratio: 4 / 3;
  display: block;
  height: auto;
  object-fit: cover;
  width: 100%;
}

.v2i-image-tile__check {
  align-items: center;
  background: var(--overlay);
  border-radius: var(--radius-full);
  color: #ffffff;
  display: flex;
  font-size: 0.875rem;
  height: 1.375rem;
  justify-content: center;
  left: 0.25rem;
  position: absolute;
  top: 0.25rem;
  width: 1.375rem;
}

.v2i-image-tile--selected .v2i-image-tile__check {
  background: var(--primary);
  color: var(--primary-foreground);
}

.v2i-image-tile__sent {
  align-items: center;
  background: var(--info-soft);
  border-radius: var(--radius-full);
  color: var(--info);
  display: flex;
  font-size: 0.6875rem;
  height: 1.25rem;
  justify-content: center;
  position: absolute;
  right: 0.25rem;
  top: 0.25rem;
  width: 1.25rem;
}

.v2i-image-tile__name {
  background: var(--overlay);
  bottom: 0;
  color: #ffffff;
  font-size: 0.625rem;
  left: 0;
  overflow: hidden;
  padding: 0.15rem 0.3rem;
  position: absolute;
  right: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.v2i-dataset-foot {
  align-items: center;
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
  margin-top: 0.75rem;
}

/* ---------- inline create (project / model) ---------- */

.v2i-inline-create {
  align-items: center;
  display: flex;
  gap: 0.375rem;
}

.v2i-inline-create .form-control {
  flex: 1 1 auto;
  min-width: 0;
}

.v2i-inline-create .btn {
  flex: 0 0 auto;
  white-space: nowrap;
}

/* ---------- "what should these images become" ---------- */

.v2i-task-grid {
  display: grid;
  gap: 0.5rem;
  grid-template-columns: repeat(auto-fit, minmax(9rem, 1fr));
  margin-bottom: 0.5rem;
}

.v2i-task-card {
  align-items: center;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  color: var(--muted-foreground);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  padding: 0.75rem 0.5rem;
  transition: border-color var(--transition-fast), color var(--transition-fast),
    background var(--transition-fast);
}

.v2i-task-card:hover:not(:disabled) {
  border-color: var(--border-strong);
  color: var(--foreground);
}

.v2i-task-card--active {
  background: var(--primary-soft);
  border-color: var(--primary);
  color: var(--primary);
}

.v2i-task-card:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.v2i-task-card__icon {
  font-size: 1.125rem;
}

.v2i-task-card__label {
  font-size: 0.75rem;
  font-weight: 600;
  text-align: center;
}

/* ---------- build progress / result ---------- */

.v2i-build-card {
  background: var(--muted);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  margin-bottom: 0.75rem;
  padding: 0.625rem 0.75rem;
}

.v2i-build-card--active {
  border-color: var(--primary);
}

.v2i-build-card__head {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.v2i-build-card__title {
  color: var(--foreground);
  font-size: 0.8125rem;
  font-weight: 600;
}

.v2i-build-card__task {
  color: var(--muted-foreground);
  font-size: 0.6875rem;
}

.v2i-build-card__spacer {
  flex: 1 1 auto;
}

.v2i-build-card__body {
  margin-top: 0.5rem;
}

.v2i-build-card__result {
  color: var(--foreground);
  font-size: 0.8125rem;
}

.v2i-dataset-head__actions {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  gap: 0.375rem;
}

.v2i-dataset-head__actions .btn {
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/pages/management/videoToImages/styles/video-to-images.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;;AAEF;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA,2CAA2C;;AAE3C;EACE,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,wBAAwB;EACxB,qBAAqB;EACrB,6BAA6B;EAC7B,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,yEAAyE;;AAEzE;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,wCAAwC;EACxC,8BAA8B;EAC9B,eAAe;EACf,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,2EAA2E;AAC7E;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,yCAAyC;;AAEzC;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,WAAW;AACb;;AAEA;EAEE,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;EAC7B,iCAAiC;EACjC,4BAA4B;EAC5B,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,iCAAiC;EACjC,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,oCAAoC;;AAEpC;EACE,mBAAmB;EACnB,iCAAiC;EACjC,uCAAuC;EACvC,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,wEAAwE;AAC1E;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,0CAA0C;;AAE1C;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,6BAA6B;EAC7B,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;EACjC,WAAW;EACX,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,kDAAkD;AACpD;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,KAAK,4BAA4B,EAAE;AACrC;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,6CAA6C;;AAE7C;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,8BAA8B;EAC9B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,aAAa;EACb,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA,oCAAoC;;AAEpC;EACE,mBAAmB;EACnB,mCAAmC;EACnC,aAAa;EACb,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,qCAAqC;;AAErC;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB;;8EAE4E;EAC5E,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB;+DAC6D;EAC7D,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;EAC9B,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,wEAAwE;AACxE;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;wCACwC;AACxC;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,6BAA6B;EAC7B,oBAAoB;EACpB,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;6DAC6D;AAC7D;EACE,uBAAuB;EACvB,oCAAoC;EACpC,gBAAgB;EAChB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,kFAAkF;EAClF,iBAAiB;EACjB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,yCAAyC;;AAEzC;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,uCAAuC;;AAEvC;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,2DAA2D;EAC3D,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,4BAA4B;EAC5B,wBAAwB;EACxB,6BAA6B;EAC7B,oBAAoB;EACpB,iBAAiB;EACjB,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,uCAAuC;;AAEvC;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA,qDAAqD;AACrD;EACE,8CAA8C;EAC9C,2CAA2C;EAC3C,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,uCAAuC;;AAEvC;EACE,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,WAAW;AACb;;AAEA,uCAAuC;;AAEvC;EACE,aAAa;EACb,YAAY;EACZ,4DAA4D;AAC9D;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,wEAAwE;EACxE,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,+BAA+B;EAC/B,8BAA8B;EAC9B,aAAa;EACb,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA,yCAAyC;;AAEzC;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,iEAAiE;AACjE;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,4BAA4B;EAC5B,aAAa;EACb,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,uDAAuD;;AAEvD;EACE,aAAa;EACb,WAAW;EACX,6DAA6D;EAC7D,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kFAAkF;AACpF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,iCAAiC;EACjC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,0DAA0D;;AAE1D;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,4DAA4D;;AAE5D;EACE,aAAa;EACb,WAAW;EACX,0DAA0D;EAC1D,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB;qCACmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,kDAAkD;;AAElD;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,4BAA4B;EAC5B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/*\n * Video → Images page.\n *\n * Every color is a design token (see src/styles/theme.css) so both themes stay\n * correct — no hardcoded hex, per DESIGN_GUIDE.md. Cards, buttons, badges and\n * the modal shell come from the existing atoms/global layer; this file only\n * adds the layout that is specific to this page.\n */\n\n.v2i-page__head {\n  padding: 0.25rem 0 0.5rem;\n}\n\n.v2i-page__title {\n  color: var(--foreground);\n  font-family: var(--font-sans);\n  font-weight: 700;\n}\n\n.v2i-page__subtitle {\n  color: var(--muted-foreground);\n  font-size: 0.8125rem;\n  max-width: 62ch;\n}\n\n.v2i-card {\n  height: 100%;\n}\n\n/* ---------- shared form bits ---------- */\n\n.v2i-label {\n  display: block;\n  color: var(--muted-foreground);\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  margin-bottom: 0.25rem;\n  text-transform: uppercase;\n}\n\n.v2i-hint {\n  color: var(--muted-foreground);\n  font-size: 0.75rem;\n  line-height: 1.45;\n}\n\n.v2i-field-group {\n  border-top: 1px solid var(--border);\n  margin-top: 0.875rem;\n  padding-top: 0.875rem;\n}\n\n.v2i-field-group:first-child {\n  border-top: 0;\n  margin-top: 0;\n  padding-top: 0;\n}\n\n.v2i-section-title {\n  color: var(--foreground);\n  font-size: 0.8125rem;\n  font-weight: 600;\n  margin: 1rem 0 0.5rem;\n}\n\n.v2i-code {\n  background: var(--muted);\n  border-radius: var(--radius-sm);\n  color: var(--foreground);\n  display: inline-block;\n  font-family: var(--font-mono);\n  font-size: 0.6875rem;\n  padding: 0.2rem 0.4rem;\n  word-break: break-all;\n}\n\n/* ---------- segmented control (sampling mode, resize mode) ---------- */\n\n.v2i-segmented {\n  background: var(--muted);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  display: flex;\n  gap: 2px;\n  padding: 2px;\n}\n\n.v2i-segmented__item {\n  background: transparent;\n  border: 0;\n  border-radius: calc(var(--radius) - 3px);\n  color: var(--muted-foreground);\n  cursor: pointer;\n  flex: 1;\n  font-size: 0.75rem;\n  font-weight: 500;\n  padding: 0.375rem 0.5rem;\n  transition: background var(--transition-fast), color var(--transition-fast);\n}\n\n.v2i-segmented__item:hover:not(:disabled) {\n  color: var(--foreground);\n}\n\n.v2i-segmented__item--active {\n  background: var(--card);\n  box-shadow: var(--shadow-sm);\n  color: var(--foreground);\n  font-weight: 600;\n}\n\n.v2i-segmented__item:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n/* ---------- quality slider ---------- */\n\n.v2i-range {\n  -webkit-appearance: none;\n  appearance: none;\n  background: transparent;\n  display: block;\n  margin: 0.25rem 0 0.375rem;\n  width: 100%;\n}\n\n.v2i-range::-webkit-slider-runnable-track {\n  background: var(--muted);\n  border-radius: var(--radius-full);\n  height: 4px;\n}\n\n.v2i-range::-moz-range-track {\n  background: var(--muted);\n  border-radius: var(--radius-full);\n  height: 4px;\n}\n\n.v2i-range::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  background: var(--primary);\n  border: 2px solid var(--card);\n  border-radius: var(--radius-full);\n  box-shadow: var(--shadow-sm);\n  cursor: pointer;\n  height: 16px;\n  margin-top: -6px;\n  width: 16px;\n}\n\n.v2i-range::-moz-range-thumb {\n  background: var(--primary);\n  border: 2px solid var(--card);\n  border-radius: var(--radius-full);\n  cursor: pointer;\n  height: 16px;\n  width: 16px;\n}\n\n.v2i-range:focus-visible {\n  outline: 2px solid var(--ring);\n  outline-offset: 3px;\n}\n\n/* ---------- drop zone ---------- */\n\n.v2i-dropzone {\n  align-items: center;\n  background: var(--page-bg-subtle);\n  border: 2px dashed var(--border-strong);\n  border-radius: var(--radius-lg);\n  display: flex;\n  flex-direction: column;\n  padding: 1.5rem 1rem;\n  text-align: center;\n  transition: background var(--transition), border-color var(--transition);\n}\n\n.v2i-dropzone--active {\n  background: var(--primary-soft);\n  border-color: var(--primary);\n}\n\n.v2i-dropzone__icon {\n  color: var(--muted-foreground);\n  font-size: 1.75rem;\n  margin-bottom: 0.5rem;\n}\n\n.v2i-dropzone__title {\n  color: var(--foreground);\n  font-size: 0.875rem;\n  font-weight: 600;\n  margin-bottom: 0.25rem;\n}\n\n.v2i-dropzone__or {\n  color: var(--muted-foreground);\n  font-size: 0.75rem;\n  margin-bottom: 0.5rem;\n}\n\n.v2i-dropzone__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  justify-content: center;\n  margin-bottom: 0.75rem;\n}\n\n/* ---------- upload progress ---------- */\n\n.v2i-upload-progress {\n  background: var(--muted);\n  border-radius: var(--radius);\n  margin-top: 0.875rem;\n  padding: 0.625rem 0.75rem;\n}\n\n.v2i-upload-progress__label {\n  color: var(--foreground);\n  font-size: 0.75rem;\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.v2i-upload-progress__value {\n  color: var(--muted-foreground);\n  flex-shrink: 0;\n  font-family: var(--font-mono);\n  font-size: 0.6875rem;\n  padding-left: 0.5rem;\n}\n\n.v2i-progress {\n  background: var(--secondary);\n  border-radius: var(--radius-full);\n  height: 6px;\n  overflow: hidden;\n  width: 100%;\n}\n\n.v2i-progress__fill {\n  background: var(--primary);\n  border-radius: var(--radius-full);\n  height: 100%;\n  transition: width var(--transition);\n}\n\n.v2i-progress__fill--active {\n  background: linear-gradient(\n    90deg,\n    var(--primary) 0%,\n    var(--brand-400) 50%,\n    var(--primary) 100%\n  );\n  background-size: 200% 100%;\n  animation: v2i-progress-shift 1.4s linear infinite;\n}\n\n@keyframes v2i-progress-shift {\n  from { background-position: 100% 0; }\n  to { background-position: -100% 0; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .v2i-progress__fill--active {\n    animation: none;\n  }\n}\n\n/* ---------- selected file list ---------- */\n\n.v2i-filelist {\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  margin-top: 0.875rem;\n  overflow: hidden;\n}\n\n.v2i-filelist__head {\n  background: var(--muted);\n  color: var(--muted-foreground);\n  display: flex;\n  font-size: 0.6875rem;\n  font-weight: 600;\n  justify-content: space-between;\n  padding: 0.375rem 0.625rem;\n  text-transform: uppercase;\n}\n\n.v2i-filelist__items {\n  list-style: none;\n  margin: 0;\n  max-height: 13rem;\n  overflow-y: auto;\n  padding: 0;\n}\n\n.v2i-filelist__item {\n  align-items: center;\n  border-top: 1px solid var(--border);\n  display: flex;\n  gap: 0.5rem;\n  padding: 0.375rem 0.625rem;\n}\n\n.v2i-filelist__item:first-child {\n  border-top: 0;\n}\n\n.v2i-filelist__icon {\n  color: var(--muted-foreground);\n  flex-shrink: 0;\n}\n\n.v2i-filelist__name {\n  color: var(--foreground);\n  flex: 1;\n  font-size: 0.75rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.v2i-filelist__size {\n  color: var(--muted-foreground);\n  flex-shrink: 0;\n  font-family: var(--font-mono);\n  font-size: 0.6875rem;\n}\n\n/* ---------- start row ---------- */\n\n.v2i-start {\n  align-items: center;\n  border-top: 1px solid var(--border);\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.625rem;\n  margin-top: 0.875rem;\n  padding-top: 0.875rem;\n}\n\n/* ---------- jobs table ---------- */\n\n.v2i-table-wrap {\n  overflow-x: auto;\n}\n\n.v2i-table {\n  border-collapse: collapse;\n  /* Wide enough for every column plus three action buttons. Below this the\n     wrapper scrolls horizontally, which is what we want — a smaller min-width\n     lets the browser crush the action cell and wrap button labels mid-word. */\n  min-width: 52rem;\n  width: 100%;\n}\n\n.v2i-table th,\n.v2i-table td {\n  padding: 0.5rem 0.5rem;\n  text-align: left;\n  vertical-align: middle;\n  /* A report row must never wrap: the one long field (job name) truncates\n     instead, everything else is short and stays on one line. */\n  white-space: nowrap;\n}\n\n.v2i-table th {\n  border-bottom: 1px solid var(--border);\n  color: var(--muted-foreground);\n  font-size: 0.6875rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  padding: 0.5rem 0.625rem;\n  text-transform: uppercase;\n}\n\n.v2i-table td {\n  border-bottom: 1px solid var(--border);\n}\n\n.v2i-table tbody tr:hover {\n  background: var(--card-hover);\n}\n\n/* The job/target cell is the only elastic one — cap it and ellipsize. */\n.v2i-table__job-col {\n  max-width: 16rem;\n  min-width: 10rem;\n  white-space: normal;\n}\n\n.v2i-table__primary {\n  color: var(--foreground);\n  font-size: 0.8125rem;\n  font-weight: 500;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.v2i-table__secondary {\n  color: var(--muted-foreground);\n  font-size: 0.6875rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Progress: bar and percentage on one line, so the column stays compact and\n   the row keeps a single-line height. */\n.v2i-table__progress-col {\n  min-width: 8.5rem;\n}\n\n.v2i-progress-cell {\n  align-items: center;\n  display: flex;\n  gap: 0.5rem;\n}\n\n.v2i-progress-cell .v2i-progress {\n  flex: 1 1 auto;\n  min-width: 4.5rem;\n}\n\n.v2i-progress-cell__value {\n  color: var(--muted-foreground);\n  flex: 0 0 auto;\n  font-family: var(--font-mono);\n  font-size: 0.6875rem;\n  font-variant-numeric: tabular-nums;\n  min-width: 2.75rem;\n  text-align: right;\n}\n\n/* Pinned to the right edge: on a narrow screen the table scrolls, and the\n   actions must not be the thing that scrolls out of reach. */\n.v2i-table__actions-col {\n  background: var(--card);\n  border-left: 1px solid var(--border);\n  position: sticky;\n  right: 0;\n  text-align: right;\n}\n\n.v2i-table tbody tr:hover .v2i-table__actions-col {\n  background: var(--card-hover);\n}\n\n.v2i-table__actions {\n  display: flex;\n  /* No wrapping: buttons stay on one row and the table scrolls if space runs out. */\n  flex-wrap: nowrap;\n  gap: 0.375rem;\n  justify-content: flex-end;\n}\n\n.v2i-table__actions .btn {\n  flex: 0 0 auto;\n  white-space: nowrap;\n}\n\n/* ---------- empty / alerts ---------- */\n\n.v2i-empty {\n  color: var(--muted-foreground);\n  padding: 2rem 1rem;\n  text-align: center;\n}\n\n.v2i-empty__icon {\n  display: block;\n  font-size: 1.75rem;\n  margin-bottom: 0.5rem;\n  opacity: 0.6;\n}\n\n.v2i-empty__title {\n  color: var(--foreground);\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n.v2i-alert {\n  border-radius: var(--radius);\n  font-size: 0.75rem;\n  line-height: 1.5;\n  margin-bottom: 0.75rem;\n  padding: 0.5rem 0.75rem;\n}\n\n.v2i-alert--danger {\n  background: var(--destructive-soft);\n  color: var(--destructive);\n}\n\n.v2i-alert--warning {\n  background: var(--warning-soft);\n  color: var(--warning);\n}\n\n.v2i-alert__list {\n  margin: 0.25rem 0 0;\n  padding-left: 1.1rem;\n}\n\n/* ---------- detail modal ---------- */\n\n.v2i-modal {\n  background: var(--overlay);\n  display: block;\n}\n\n.v2i-detail-grid {\n  display: grid;\n  gap: 0.75rem 1rem;\n  grid-template-columns: repeat(auto-fit, minmax(13rem, 1fr));\n  margin-bottom: 0.875rem;\n}\n\n.v2i-detail-grid p {\n  color: var(--foreground);\n  font-size: 0.8125rem;\n}\n\n.v2i-skiplist {\n  list-style: none;\n  margin: 0 0 0.5rem;\n  padding: 0;\n}\n\n.v2i-skiplist li {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  padding: 0.2rem 0;\n}\n\n.v2i-log {\n  background: var(--muted);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  color: var(--foreground);\n  font-family: var(--font-mono);\n  font-size: 0.6875rem;\n  line-height: 1.55;\n  margin: 0;\n  max-height: 14rem;\n  overflow: auto;\n  padding: 0.625rem;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n/* ---------- table extras ---------- */\n\n.v2i-table__icon {\n  color: var(--muted-foreground);\n  margin-right: 0.375rem;\n}\n\n/* Danger tint for an icon-only destructive action. */\n.v2i-icon-btn--danger:hover:not(:disabled) {\n  background: var(--destructive-soft) !important;\n  border-color: var(--destructive) !important;\n  color: var(--destructive) !important;\n}\n\n.v2i-hint--info {\n  color: var(--info);\n  margin-top: 0.25rem;\n}\n\n.v2i-alert--info {\n  background: var(--info-soft);\n  color: var(--info);\n}\n\n/* ---------- checkbox row ---------- */\n\n.v2i-checkbox {\n  align-items: center;\n  color: var(--foreground);\n  cursor: pointer;\n  display: flex;\n  font-size: 0.8125rem;\n  gap: 0.5rem;\n  margin: 0.5rem 0 0;\n}\n\n.v2i-checkbox input {\n  accent-color: var(--primary);\n  height: 1rem;\n  width: 1rem;\n}\n\n/* ---------- dataset list ---------- */\n\n.v2i-dataset-grid {\n  display: grid;\n  gap: 0.75rem;\n  grid-template-columns: repeat(auto-fill, minmax(15rem, 1fr));\n}\n\n.v2i-dataset-card {\n  align-items: center;\n  background: var(--card);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  cursor: pointer;\n  display: flex;\n  gap: 0.75rem;\n  padding: 0.625rem;\n  text-align: left;\n  transition: border-color var(--transition), box-shadow var(--transition);\n  width: 100%;\n}\n\n.v2i-dataset-card:hover {\n  border-color: var(--primary);\n  box-shadow: var(--shadow-sm);\n}\n\n.v2i-dataset-card__thumb {\n  align-items: center;\n  background: var(--muted);\n  border-radius: var(--radius-sm);\n  color: var(--muted-foreground);\n  display: flex;\n  flex: 0 0 auto;\n  height: 3rem;\n  justify-content: center;\n  overflow: hidden;\n  width: 3rem;\n}\n\n.v2i-dataset-card__thumb img {\n  height: 100%;\n  object-fit: cover;\n  width: 100%;\n}\n\n.v2i-dataset-card__body {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.v2i-dataset-card__name {\n  color: var(--foreground);\n  font-size: 0.8125rem;\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.v2i-dataset-card__count {\n  color: var(--muted-foreground);\n  font-size: 0.6875rem;\n}\n\n/* ---------- dataset detail ---------- */\n\n.v2i-dataset-head {\n  align-items: center;\n  display: flex;\n  gap: 0.625rem;\n  min-width: 0;\n}\n\n.v2i-dataset-head__name {\n  color: var(--foreground);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Keep the back button on one line when the header gets tight. */\n.v2i-dataset-head .btn {\n  flex: 0 0 auto;\n  white-space: nowrap;\n}\n\n.v2i-select-bar {\n  align-items: center;\n  background: var(--muted);\n  border-radius: var(--radius);\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.625rem;\n  justify-content: space-between;\n  margin-bottom: 0.875rem;\n  padding: 0.5rem 0.625rem;\n}\n\n.v2i-select-bar__left,\n.v2i-select-bar__right {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.v2i-select-bar__count {\n  color: var(--muted-foreground);\n  font-size: 0.75rem;\n}\n\n/* ---------- image grid with multi-select ---------- */\n\n.v2i-image-grid {\n  display: grid;\n  gap: 0.5rem;\n  grid-template-columns: repeat(auto-fill, minmax(7.5rem, 1fr));\n  max-height: 32rem;\n  overflow-y: auto;\n}\n\n.v2i-image-tile {\n  background: var(--muted);\n  border: 2px solid transparent;\n  border-radius: var(--radius);\n  cursor: pointer;\n  overflow: hidden;\n  position: relative;\n  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);\n}\n\n.v2i-image-tile:hover {\n  border-color: var(--border-strong);\n}\n\n.v2i-image-tile:focus-visible {\n  outline: 2px solid var(--ring);\n  outline-offset: 2px;\n}\n\n.v2i-image-tile--selected {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 2px var(--primary-soft);\n}\n\n.v2i-image-tile__img {\n  aspect-ratio: 4 / 3;\n  display: block;\n  height: auto;\n  object-fit: cover;\n  width: 100%;\n}\n\n.v2i-image-tile__check {\n  align-items: center;\n  background: var(--overlay);\n  border-radius: var(--radius-full);\n  color: #ffffff;\n  display: flex;\n  font-size: 0.875rem;\n  height: 1.375rem;\n  justify-content: center;\n  left: 0.25rem;\n  position: absolute;\n  top: 0.25rem;\n  width: 1.375rem;\n}\n\n.v2i-image-tile--selected .v2i-image-tile__check {\n  background: var(--primary);\n  color: var(--primary-foreground);\n}\n\n.v2i-image-tile__sent {\n  align-items: center;\n  background: var(--info-soft);\n  border-radius: var(--radius-full);\n  color: var(--info);\n  display: flex;\n  font-size: 0.6875rem;\n  height: 1.25rem;\n  justify-content: center;\n  position: absolute;\n  right: 0.25rem;\n  top: 0.25rem;\n  width: 1.25rem;\n}\n\n.v2i-image-tile__name {\n  background: var(--overlay);\n  bottom: 0;\n  color: #ffffff;\n  font-size: 0.625rem;\n  left: 0;\n  overflow: hidden;\n  padding: 0.15rem 0.3rem;\n  position: absolute;\n  right: 0;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.v2i-dataset-foot {\n  align-items: center;\n  display: flex;\n  gap: 0.75rem;\n  justify-content: space-between;\n  margin-top: 0.75rem;\n}\n\n/* ---------- inline create (project / model) ---------- */\n\n.v2i-inline-create {\n  align-items: center;\n  display: flex;\n  gap: 0.375rem;\n}\n\n.v2i-inline-create .form-control {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.v2i-inline-create .btn {\n  flex: 0 0 auto;\n  white-space: nowrap;\n}\n\n/* ---------- \"what should these images become\" ---------- */\n\n.v2i-task-grid {\n  display: grid;\n  gap: 0.5rem;\n  grid-template-columns: repeat(auto-fit, minmax(9rem, 1fr));\n  margin-bottom: 0.5rem;\n}\n\n.v2i-task-card {\n  align-items: center;\n  background: var(--card);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  color: var(--muted-foreground);\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  gap: 0.375rem;\n  padding: 0.75rem 0.5rem;\n  transition: border-color var(--transition-fast), color var(--transition-fast),\n    background var(--transition-fast);\n}\n\n.v2i-task-card:hover:not(:disabled) {\n  border-color: var(--border-strong);\n  color: var(--foreground);\n}\n\n.v2i-task-card--active {\n  background: var(--primary-soft);\n  border-color: var(--primary);\n  color: var(--primary);\n}\n\n.v2i-task-card:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.v2i-task-card__icon {\n  font-size: 1.125rem;\n}\n\n.v2i-task-card__label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-align: center;\n}\n\n/* ---------- build progress / result ---------- */\n\n.v2i-build-card {\n  background: var(--muted);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  margin-bottom: 0.75rem;\n  padding: 0.625rem 0.75rem;\n}\n\n.v2i-build-card--active {\n  border-color: var(--primary);\n}\n\n.v2i-build-card__head {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.v2i-build-card__title {\n  color: var(--foreground);\n  font-size: 0.8125rem;\n  font-weight: 600;\n}\n\n.v2i-build-card__task {\n  color: var(--muted-foreground);\n  font-size: 0.6875rem;\n}\n\n.v2i-build-card__spacer {\n  flex: 1 1 auto;\n}\n\n.v2i-build-card__body {\n  margin-top: 0.5rem;\n}\n\n.v2i-build-card__result {\n  color: var(--foreground);\n  font-size: 0.8125rem;\n}\n\n.v2i-dataset-head__actions {\n  align-items: center;\n  display: flex;\n  flex-shrink: 0;\n  gap: 0.375rem;\n}\n\n.v2i-dataset-head__actions .btn {\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
